import React from 'react';
import { motion } from 'framer-motion';

export const LoadingOverlay = ({ message = 'Creating your look...' }) => (
  <motion.div
    initial={{ opacity: 0 }}
    animate={{ opacity: 1 }}
    exit={{ opacity: 0 }}
    className="absolute inset-0 bg-white/90 backdrop-blur-sm flex flex-col items-center justify-center z-30"
  >
    <div className="relative">
      <div className="w-16 h-16 border-4 border-blue-100 rounded-full" />
      <div className="absolute inset-0 w-16 h-16 border-4 border-blue-600 border-t-transparent rounded-full animate-spin" />
    </div>
    <p className="mt-4 text-slate-600 text-sm font-medium">{message}</p>
  </motion.div>
);
